import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'toggle']

  toggle () {
    const isHidden = this.inputTarget.type === 'password'
    this.inputTarget.type = isHidden ? 'text' : 'password'
    this.toggleTarget.setAttribute('aria-pressed', String(isHidden))
    this.toggleTarget.setAttribute('aria-label', isHidden ? this.toggleTarget.dataset.hideLabel : this.toggleTarget.dataset.showLabel)
    this.toggleTarget.querySelector('i').className = isHidden ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'
  }
}
